import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";

const styles = makeStyles(() => ({
  reportSubheader: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "20px",
    color: getBrandCustom("primaryColor", "#308CDB"),
  },
}));

export default styles;
